// [ai] The Vega runtime behind the vega widget, loaded on first use as its own chunk (vega + vega-lite are ~1.5 MB; a dashboard
// without a chart never pays). The expression interpreter replaces Vega's code generation so the chart runs under the app's CSP
// (no eval). Tests mock this module.
export type VegaSpec = Record<string, unknown>;
export async function renderVega(el: HTMLElement, spec: VegaSpec, values: unknown[] | undefined, dark: boolean): Promise<() => void> {
  const [{ default: embed }, { expressionInterpreter }] = await Promise.all([import("vega-embed"), import("vega-interpreter")]);
  const full = values ? { ...spec, data: { values } } : spec;
  const r = await embed(el, full as never, { actions: false, renderer: "svg", ast: true, expr: expressionInterpreter as never, theme: dark ? "dark" : undefined, config: { background: "transparent" } });
  return () => r.finalize();
}
